import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// components
import LtoPurchaesOrderHistoryItem from './LtoPurchaesOrderHistoryItem';
import Anchor from 'Components/lto/common/Anchor';
import Header from 'Components/lto/common/Header';
import SearchInput from 'Components/lto/common/SearchInput';
import ScrollWrapper from 'Components/lto/common/ScrollWrapper';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import Checkbox from '@material-ui/core/Checkbox';
import Select from 'Components/lto/common/Select';
import {openNotification} from 'Actions/notification';
import BasicTextArea from 'Components/common/BasicTextArea';

import {
    getLtoPurchaseOrderHistoryList,
    updateLtoPurchaseOrderHistoryTabActive,
    updateLtoPurchaseOrderHistoryList,
    getNotificationChannel,
    reminderNotification,
    cancelOrder,
    clearLtoListData,
} from 'Actions/ltoPurchaseOrder';
import {T} from 'Actions/translate';

class LtoHistoryList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    state = {
        tabList: [
            {
                index: 0,
                text: T('lto_history_order_wait_cusotmer_confirm'),
                tabFlag: 1,
                testid: 'preorder-history-pending-tab',
                name: 'noReceive',
            },
            {
                index: 1,
                text: T('lto_history_order_cusotmer_confirm'),
                tabFlag: 2,
                testid: 'preorder-history-confirmed-tab',
                name: 'received',
            },
            {
                index: 2,
                text: T('lto_history_order_cusotmer_cancel'),
                tabFlag: 3,
                testid: 'preorder-history-canceled-tab',
                name: 'canceled',
            },
        ],
        purchaseOrderHistoryTabActive: 0,
        listLoaded: true,
        seletedItem: null,
        receiveShipment: null,
        searchValue: '',
        phoneNumberList: [],
        phoneNumberId: '',
        defaultEmail: '',
        isSMS: false,
        isEmail: false,
        isOpenNotificationDialog: false,
        loading: false,
        orderNumber: '',
        notificationMethods: [],
        isMobilityNotification: true,
        cancelOrderDialogOpened: false,
        ltoOrderItemDetail: {},
        currentCancelReason: '',
    };

    async componentWillMount() {
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        this.getList();
    }

    componentWillUnmount() {
        this.props.clearLtoListData();
    }

    getList = (reload, isSeach) => {
        const {purchaseOrderHistoryTabActive} = this.props;
        if (!isSeach && this.pager.page >= this.pager.pageTotal) return;
        this.setState({listLoaded: false});

        let orderStatusValue = '';
        if (this.state.tabList[purchaseOrderHistoryTabActive].tabFlag === 1) {
            orderStatusValue = 'To_Be_Confirmed';
        } else if (
            this.state.tabList[purchaseOrderHistoryTabActive].tabFlag === 2
        ) {
            orderStatusValue = 'Confirmed';
        } else if (
            this.state.tabList[purchaseOrderHistoryTabActive].tabFlag === 3
        ) {
            orderStatusValue = 'Cancelled';
        }
        const {searchValue} = this.state;
        this.props
            .getLtoPurchaseOrderHistoryList({
                pageNum: reload ? 1 : this.pager.page + 1,
                pageSize: this.pager.length,
                keyword: searchValue ? searchValue.trim() : '',
                orderStatus: [orderStatusValue],
            })
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({listLoaded: true});
            });
    };

    //顶部搜索框
    changeSearchInput = (title, value) => {
        this.setState({
            searchValue: value,
        });
    };

    search = () => {
        this.props.updateLtoPurchaseOrderHistoryList([]);
        let isSeach = true;
        this.getList(true, isSeach);
    };
    /**
     * Handle change tab
     * @item { Object } This is a tab item.
     */
    handleChangeTab = (item) => {
        this.props.updateLtoPurchaseOrderHistoryTabActive({$set: item.index});
        this.setState({purchaseOrderHistoryTabActive: item.index}, () => {
            this.pager.page = 0;
            this.pager.total = 0;
            this.pager.pageTotal = 9999999999999999999999999;
            this.getList(true);
        });
    };

    chooseItem = (item) => {
        this.props.history.push(`/ltoPurchaesOrderHistoryDetails`, {
            serialNumber: item.number,
        });
    };

    gotoMyOrderList = (salesOrderNumber, e) => {
        this.props.history.push(`/myOrderDetail`, {
            fromLto: true,
            orderNumber: salesOrderNumber,
        });
    };

    gotoResendNotification = (item) => {
        let params = {
            receiverTel: item.receiverTel,
            email: item.customerEmail ? item.customerEmail : '',
            shipTo: item.shipToNumber,
        };

        this.props.getNotificationChannel(params).then((res) => {
            if (
                res &&
                res.status === 'success' &&
                res.data &&
                res.data.length > 0
            ) {
                let resendNotificationData = [];
                let tempDefaultEmail = '';
                res.data.map((receiverItem, receiverIndex) => {
                    if (receiverItem.method === 'mail') {
                        tempDefaultEmail = receiverItem.receiver;
                    } else if (receiverItem.method === 'sms') {
                        let tempPhoneNumberArr = receiverItem.receiver
                            ? receiverItem.receiver.split(',')
                            : '';
                        tempPhoneNumberArr.length > 0 &&
                            tempPhoneNumberArr.map(
                                (tempPhoneItem, tempPhoneIndex) => {
                                    resendNotificationData.push({
                                        id: ++tempPhoneIndex,
                                        name: tempPhoneItem,
                                    });
                                },
                            );
                    }
                });

                this.setState(
                    {
                        defaultEmail: tempDefaultEmail,
                        phoneNumberList: resendNotificationData,
                        orderNumber: item.number,
                        phoneNumber:
                            resendNotificationData.length > 0
                                ? resendNotificationData[0].name
                                : '',
                        phoneNumberId:
                            resendNotificationData.length > 0
                                ? resendNotificationData[0].id
                                : '',
                    },
                    () => {
                        this.setState({
                            isOpenNotificationDialog: true,
                        });
                    },
                );
            }
        });
    };

    getFromPage = () => {
        let fromOrderSuccess = false;
        let routerState = util.getRouterState(
            this.props.history.location.state,
        );
        if (JSON.stringify(routerState) !== '{}') {
            fromOrderSuccess = routerState.fromOrderSuccess;
        }
        return fromOrderSuccess;
    };

    goBack = () => {
        if (this.getFromPage()) {
            this.props.history.push('/purchase/orderSuccess');
        } else {
            this.props.history.goBack();
        }
    };

    handleCustomerConfirmationChannel = (params, value) => {
        const {
            phoneNumberList,
            emailList,
            phoneNumberId,
            defaultEmail,
            emailId,
        } = this.state;
        this.setState(
            {
                [params]: !value,
            },
            () => {
                const {isSMS, isEmail, notificationMethods, defaultEmail} =
                    this.state;
                let tempNotificationMethods = [];
                if (params === 'isSMS') {
                    if (isSMS) {
                        let isSMSObj = {
                            method: 'sms',
                            receiver: '',
                        };
                        if (phoneNumberList.length > 0) {
                            let currentPhoneObj = {};
                            phoneNumberList.forEach((phoneItem) => {
                                if (
                                    phoneNumberId &&
                                    phoneNumberId === phoneItem.id &&
                                    phoneItem.name
                                ) {
                                    currentPhoneObj = phoneItem;
                                }
                            });

                            isSMSObj.receiver = currentPhoneObj.name;
                        }
                        tempNotificationMethods.push(isSMSObj);
                        tempNotificationMethods =
                            tempNotificationMethods.concat(
                                this.state.notificationMethods,
                            );
                    } else {
                        const newNotificationMethods =
                            notificationMethods.filter(
                                (obj) => obj.method !== 'sms',
                            );
                        tempNotificationMethods = newNotificationMethods;
                    }
                }

                if (params === 'isEmail') {
                    if (isEmail) {
                        let isEmailObj = {
                            method: 'mail',
                            receiver: '',
                        };

                        if (defaultEmail) {
                            isEmailObj.receiver = defaultEmail;
                        }
                        tempNotificationMethods.push(isEmailObj);
                        tempNotificationMethods =
                            tempNotificationMethods.concat(
                                this.state.notificationMethods,
                            );
                    } else {
                        const newNotificationMethods =
                            notificationMethods.filter(
                                (obj) => obj.method !== 'mail',
                            );
                        tempNotificationMethods = newNotificationMethods;
                    }
                }

                this.setState({
                    notificationMethods: tempNotificationMethods,
                });
            },
        );
    };

    handleSelectChange = (name, value) => {
        console.log(name, '999999999999999999999999999999999999999', value);
        const {phoneNumberList, notificationMethods} = this.state;
        let currentNotificationMethods = JSON.parse(
            JSON.stringify(notificationMethods),
        );

        currentNotificationMethods.forEach((notificationItem) => {
            if (notificationItem.method === 'sms') {
                notificationItem.receiver = name.name;
            }
        });
        this.setState({
            phoneNumberId: name.name ? name.id : '',
            notificationMethods: currentNotificationMethods,
        });
    };
    resendNotificationHandle = () => {
        const {orderNumber, notificationMethods} = this.state;

        if (notificationMethods.length > 0) {
            let emptySmsFlag = false;
            notificationMethods.map((notificationItem, notificationIndex) => {
                if (
                    notificationItem.method === 'sms' &&
                    !notificationItem.method
                ) {
                    emptySmsFlag = true;
                }
            });
            if (emptySmsFlag) {
                this.props.openNotification(
                    T('customer_confirmation_channel_checked_sms_not_empty'),
                    'danger',
                );
                this.resetResentNotificationParam();
            } else {
                this.props
                    .reminderNotification({
                        number: orderNumber,
                        notificationMethods: notificationMethods,
                    })
                    .then((res) => {
                        if (res && res.status === 'success') {
                            this.props.openNotification(
                                T('lto_history_list_notification_send_success'),
                                'success',
                            );
                        }

                        this.resetResentNotificationParam();
                        // this.props.history.replace('/myOrderList/canceled');
                    });
            }
        } else {
            this.resetResentNotificationParam();
            this.props.openNotification(
                T('lto_history_detail_resend_channel_is_not_empty'),
                'danger',
            );
        }
    };

    resetResentNotificationParam = () => {
        this.setState({
            orderNumber: '',
            notificationMethods: [],
            isOpenNotificationDialog: false,
            phoneNumberList: [],
            defaultEmail: '',
            isSMS: false,
            isEmail: false,
            phoneNumberId: '',
        });
    };

    closeNotificationDialog = () => {
        this.resetResentNotificationParam();
    };

    dialogDidClose = (dialog) => {
        this.state[dialog] && this.setState({[dialog]: false});
    };

    openCancelOrderDialog = (myOrderItemDetail) => {
        let orderId = myOrderItemDetail.number;
        if (orderId) {
            this.setState({
                cancelOrderDialogOpened: true,
                ltoOrderItemDetail: myOrderItemDetail,
            });
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };
    cancelOrder = () => {
        const {ltoOrderItemDetail, currentCancelReason} = this.state;
        let orderId = ltoOrderItemDetail.number;
        if (orderId) {
            if (currentCancelReason && currentCancelReason.length > 90) {
                this.props.openNotification(
                    T('notification_cancel_reason_not_exceed_90'),
                    'danger',
                );
            } else {
                this.props
                    .cancelOrder(
                        {number: orderId, cancelReason: currentCancelReason},
                        (res) => {
                            this.setState({cancelOrderDialogOpened: false});

                            if (res.status === 'success') {
                                this.props.openNotification(
                                    T(
                                        'notification_successfully_cancel_the_order',
                                    ),
                                    'success',
                                );
                                this.props.updateLtoPurchaseOrderHistoryList(
                                    [],
                                );
                                let isSeach = true;
                                this.getList(true, isSeach);
                            } else {
                                this.props.openNotification(
                                    T('notification_order_cancellation_failed'),
                                    'success',
                                );
                            }
                        },
                    )
                    .catch((err) => {
                        this.setState({
                            cancelOrderDialogOpened: false,
                            currentCancelReason: '',
                        });
                        if (err.status === 'squote_order_not_allowed') {
                            this.setState({sQuoteFailureDialogOpened: true});
                        } else if (
                            err.status === 'integration_error' &&
                            err.message === 'order_has_confirmed'
                        ) {
                            this.props.openNotification(
                                T('order_has_confirmed'),
                                'danger',
                            );
                        }
                    });
            }
        } else {
            this.props.openNotification(T('order_does_not_exist'), 'danger');
        }
    };

    closeCancelOrder = () => {
        this.setState({cancelOrderDialogOpened: false});
    };

    handleOnInput = (name, value) => {
        this.setState({currentCancelReason: value});
    };

    render() {
        let {ltoPurchaseOrderHistoryList, purchaseOrderHistoryTabActive} =
            this.props;
        let {
            tabList,
            listLoaded,
            searchValue,
            isOpenNotificationDialog,
            phoneNumberList,
            phoneNumberId,
            defaultEmail,
            isEmail,
            isSMS,
            loading,
            isMobilityNotification,
            ltoOrderItemDetail,
            cancelOrderDialogOpened,
            currentCancelReason,
        } = this.state;

        return (
            <div className="lto-purchase-order-history-list-container">
                <Header
                    hasArrowBackIos={true}
                    hasShoppingCart={false}
                    hasUserCenter={true}
                    headerTitle={T('lto_history_list')}
                    backEvent={this.goBack}>
                    <div className="header-box">
                        {/* <h3 className="header-title">
                            {T('lto_history_list')}
                        </h3> */}
                        <SearchInput
                            title="queryKey"
                            testid="preorder-history-search-input"
                            value={searchValue}
                            placeholder={T('lto_history_list_placeholder')}
                            onChange={this.changeSearchInput}
                            search={this.search}></SearchInput>
                    </div>
                    <div className="tab-header">
                        {tabList.map((item, index) => (
                            <Anchor
                                key={index}
                                className={util.getClassName({
                                    'tab-item': true,
                                    active:
                                        index === purchaseOrderHistoryTabActive,
                                })}
                                testid={item.testid}
                                onClickOfSingleTap={() => {
                                    this.handleChangeTab(item);
                                }}>
                                {item.text}
                            </Anchor>
                        ))}
                    </div>
                </Header>
                <ScrollWrapper
                    listLoaded={listLoaded}
                    showAbyss={this.pager.page >= this.pager.pageTotal}
                    showLoadingMore={!listLoaded}
                    getMoreData={() => {
                        this.getList(false);
                    }}>
                    <ul className="lto-purchase-order-history-list">
                        {ltoPurchaseOrderHistoryList &&
                        ltoPurchaseOrderHistoryList.length > 0
                            ? ltoPurchaseOrderHistoryList.map((item, index) => (
                                  <li
                                      key={index}
                                      className="lto-purchase-order-history-item">
                                      <LtoPurchaesOrderHistoryItem
                                          item={item}
                                          chooseItem={() =>
                                              this.chooseItem(item)
                                          }
                                          gotoMyOrderList={this.gotoMyOrderList}
                                          gotoResendNotification={
                                              this.gotoResendNotification
                                          }
                                          openCancelOrderDialog={
                                              this.openCancelOrderDialog
                                          }
                                      />
                                  </li>
                              ))
                            : null}
                    </ul>
                </ScrollWrapper>

                <Dialog
                    dialogDidClose={this.closeNotificationDialog}
                    opened={isOpenNotificationDialog}
                    options={{bgClickClose: true}}>
                    <div
                        className="lto-detail-resend-dialog"
                        testid="preorder-history-resend-dialog">
                        <h5 className="lto-detail-resend-dialog-title text-center">
                            {T('lto_history_list_resend_notification')}
                        </h5>
                        <div className="lto-detail-resend-dialog-desc text-center">
                            <div className="confirmation-channel-option">
                                <Checkbox
                                    checked={isMobilityNotification}
                                    onChange={this.handleCustomerConfirmationChannel.bind(
                                        this,
                                        'isMobilityNotification',
                                        isMobilityNotification,
                                    )}
                                    disabled={true}
                                    className="checkbox-button"
                                />
                                <span className="all-selected-title">
                                    {T('lto_purchase_order_mobility')}
                                </span>
                            </div>
                            <div className="confirmation-channel-option">
                                <Checkbox
                                    checked={isSMS}
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                        'data-testid':
                                            'preorder-history-resend-sms-checkbox',
                                    }}
                                    onChange={this.handleCustomerConfirmationChannel.bind(
                                        this,
                                        'isSMS',
                                        isSMS,
                                    )}
                                    className="checkbox-button"
                                />
                                <span className="all-selected-title">
                                    <label className="default-email-label">
                                        {T('phoneNumber')}
                                    </label>
                                    <Select
                                        className="select"
                                        value={phoneNumberId}
                                        placeholder={T(
                                            'select_customer_confirmation_channel_phone_number',
                                        )}
                                        data={phoneNumberList}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={this.handleSelectChange}
                                        isDialog={true}
                                        options={{
                                            icon: {
                                                show: true,
                                                color: '#E82D38',
                                            },
                                        }}
                                    />
                                </span>
                            </div>
                            <div className="confirmation-channel-option">
                                <Checkbox
                                    checked={isEmail}
                                    inputProps={{
                                        'aria-label': 'secondary checkbox',
                                        'data-testid':
                                            'preorder-history-resend-email-checkbox',
                                    }}
                                    onChange={this.handleCustomerConfirmationChannel.bind(
                                        this,
                                        'isEmail',
                                        isEmail,
                                    )}
                                    className="checkbox-button"
                                />
                                <div className="all-selected-title">
                                    <label className="default-email-label">
                                        {T('defaultEmail')}
                                    </label>
                                    <div className="default-email">
                                        {defaultEmail}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tag-upload-btn-container">
                            <BasicButton
                                className="cancel-confirm-btn"
                                testid="preorder-history-resend-cancel-btn"
                                onClickOfSingleTap={
                                    this.closeNotificationDialog
                                }>
                                {T('cancel')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="receive-confirm-btn"
                                testid="preorder-history-resend-confirm-btn"
                                loading={loading}
                                onClickOfSingleTap={
                                    this.resendNotificationHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={cancelOrderDialogOpened}
                    dialogDidClose={this.closeCancelOrder}
                    options={{bgClickClose: true}}>
                    <div className="cancel-order-dialog">
                        <h5 className="cancel-order-dialog-title text-center">
                            {T('order_confirm_cancel_order')}
                        </h5>
                        <p className="cancel-order-dialog-desc text-center">
                            <BasicTextArea
                                title={'lto_history_list_cancel_reason'}
                                placeholder={
                                    'lto_history_list_cancel_reason_placeholder'
                                }
                                defalutValue={currentCancelReason}
                                inputValid={this.handleOnInput}
                                isSearchChange={true}
                                rows={3}
                                type="text"
                                value={currentCancelReason}
                            />
                        </p>
                        <div className="dialog-footer-btn">
                            <BasicButton
                                type="primary"
                                className="cancel-order-confirm-btn"
                                onClickOfSingleTap={this.closeCancelOrder}>
                                {T('btn_action_cancel')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="confirm-cancel-order-btn"
                                onClickOfSingleTap={this.cancelOrder}>
                                {T('order_confirm')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData, ltoPurchaseOrder} = state;
    return {
        localData: localData,
        ltoPurchaseOrderHistoryList:
            ltoPurchaseOrder.ltoPurchaseOrderHistoryList,
        purchaseOrderHistoryTabActive:
            ltoPurchaseOrder.purchaseOrderHistoryTabActive,
        notificationChannel: ltoPurchaseOrder.notificationChannel,
        reminderNotification: ltoPurchaseOrder.reminderNotification,
    };
};

const mapDispatchToProps = {
    getLtoPurchaseOrderHistoryList,
    updateLtoPurchaseOrderHistoryTabActive,
    updateLtoPurchaseOrderHistoryList,
    getNotificationChannel,
    reminderNotification,
    openNotification,
    cancelOrder,
    clearLtoListData,
};

export default connect(mapStateToProps, mapDispatchToProps)(LtoHistoryList);
